<template>
    <div class="page">
        <div class="base">
            <img src="https://cosimg.cdbost.cn/cdboost/sy/index001.png" alt="">
        </div>
        <div class="base">
            <div class="title-box">
                <span class="title">解决方案支持体系</span>
            </div>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/index02.jpg" alt="">
            <p class="remake">解决方案囊括电动汽车充电、电瓶车充电和电动车停车场无人值守，依托云计算、人工智能分析、为客户提供安全充电、优质运营服务</p>
        </div>
        <div class="base">
            <div class="title-box">
                <span class="title">产品体系</span>
            </div>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/index04.jpg" alt="">
            <ul class="list0">
                <li v-for="item in list0" :style="item.style">
                    <div v-html="item.text"></div>
                </li>
            </ul>
        </div>
        <div class="base">
            <div class="title-box">
                <span class="title">选择电管家充电原因</span>
            </div>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/index05.jpg" alt="">
            <ul class="list1">
                <li v-for="item in list">
                    <span>{{item.text}}</span>
                </li>
            </ul>
        </div>
        <div class="base">
            <div class="title-box">
                <span class="title">电管家优势</span>
            </div>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/index06.jpg" alt="">
            <ul class="list2">
                <li v-for="(item, index) in list2">
                    <div v-if="index % 2" class="list2-box" :style="item.style">
                        <div :style="{color: item.color}" class="value">{{item.value}}<span class="unit" v-html="item.unit"></span></div>
                        <div style="margin-top: 0.2rem">{{item.text}}</div>
                    </div>
                    <div v-else :style="item.style" class="list2-box">
                        <div style="margin-bottom: 0.5rem">{{item.text}}</div>
                        <div :style="{color: item.color}" class="value">{{item.value}}</div>
                        <div :style="{color: item.color}">{{item.unit}}</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="base">
            <div class="title-box">
                <span class="title">成功案例</span>
            </div>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/index07.jpg" alt="">
            <ul class="list3">
                <li v-for="item in list3" :style="item.style">{{item.text}}</li>
            </ul>
        </div>
        <div class="base white">
            <div class="title-box">
                <span class="title">市场疆域</span>
            </div>
            <img src="https://cosimg.cdbost.cn/cdboost/sy/index18.jpg" alt="">
            <ul class="list4">
                <li v-for="item in list4">
                    <span>{{item}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "app",
        data() {
            return {
                list0: [
                    {text: "汽车交流充电", style: {left: '17rem', top: '17rem'} },
                    {text: "智能有序充电", style: {left: '21rem', top: '31rem'} },
                    {text: "电瓶车充电", style: {left: '19rem', top: '50rem'} },
                    {text: "集中式充电", style: {right: '8rem', top: '16rem'} },
                    {text: "智慧</br>车场", style: {right: '7rem', top: '34rem'} },
                    {text: "消防安全", style: {right: '12rem', top: '53rem'} },
                ],
                list: [
                    {text: "独有智能有序充电"},
                    {text: "强大充电运营平台"},
                    {text: "高度产品集成"},
                    {text: "多年行业积累"},
                    {text: "顶级研发团队"},
                    {text: "独特产品研发方案"},
                    {text: "多远场景支持"},
                    {text: "产品自主设计"},
                ],
                list2: [
                    {text: "安全充电", value: '3000', unit: '万次', color: '#4CAC48', style: {left: '3rem', top: '29rem'} },
                    {text: "安装部署", value: '10', unit: '分钟', color: '#FF9846', style: {left: '18rem', top: '21rem'} },
                    {text: "过载提醒", value: '5000', unit: '次', color: '#CB8899', style: {left: '32.5rem', top: '36rem'}},
                    {text: "设备故障率", value: '0.6', unit: '%', color: '#B936AA', style: {left: '46.8rem', top: '21rem'}},
                    {text: "充电突变", value: '12', unit: '万次', color: '#F1C91C', style: {left: '60.5rem', top: '36rem'}},
                    {text: "充电成功率", value: '99', unit: '%', color: '#6D56D8', style: {right: '33.8rem', top: '21rem'}},
                    {text: "异常充电", value: '5', unit: '万次', color: '#0070D3', style: {right: '20.3rem', top: '36rem'}},
                    {text: "绿色电能", value: '5000', unit: '<div>万度</div>', color: '#35B0D1', style: {right: '4rem', top: '29rem'}},
                ],
                list3: [
                    {text: "社区充电", style: {left: '21rem', top: '54rem'} },
                    {text: "商超充电", style: {left: '44rem', top: '25rem'} },
                    {text: "学校", style: {color: 'white', left: '84rem', top: '25rem'} },
                    {text: "园区充电", style: {right: '3rem', top: '11.5rem'} },
                ],
                list4: ['覆盖省份', '合作运营商', '服务车主', '充电插座', '安全充电']
            };
        },
        created() {

        }
    };
</script>

<style lang="scss">
    .base{
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
        .title-box{
            color: #1B5AA7;
            position: absolute;
            width: 100%;
            text-align: center;
            font-size: 3rem;
            font-weight: 600;
            padding-top: 2rem;
            .title{
                position: relative;
                &:after{
                    content: '';
                    background: #1B5AA7;
                    position: absolute;
                    bottom: -1rem;
                    height: 0.5rem;
                    width: 100%;
                    left: 0;
                    border-radius: 0.5rem;
                }
            }
        }
        .remake{
            position: absolute;
            color: #333333;
            bottom: 2rem;
            font-size: 1.7rem;
            text-align: center;
            width: 100%;
        }
        img{
            width: 100%;
        }
        .list0{
            top: 0;
            left: 0;
            height: 100%;
            position: absolute;
            font-size: 1.5rem;
            text-align: center;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            li{
                position: absolute;
                color: #2765AD;
                span{
                    position: absolute;
                    bottom: 2.5em;
                    width: 100%;
                    text-align: center;
                    left: 0;
                }
            }
        }
        .list1{
            bottom: 0;
            position: absolute;
            font-size: 2rem;
            text-align: center;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            li{
                position: relative;
                width: 25%;
                height: 25rem;
                span{
                    position: absolute;
                    bottom: 2.5em;
                    width: 100%;
                    text-align: center;
                    left: 0;
                }
            }
        }
        .list2{
            font-size: 2rem;
            top: 0;
            position: absolute;
            text-align: center;
            left: 0;
            width: 100%;
            .list2-box{
                position: absolute;
                width: 10.5rem;
            }
            .value{
                font-weight: 600;
                font-size: 3rem;
            }
            .unit{
                font-size: 2rem;
                font-weight: normal;
            }
        }
        .list3{
            font-size: 3rem;
            top: 0;
            position: absolute;
            text-align: center;
            left: 0;
            width: 100%;
            li{
                position: absolute;
                text-align: center;
                width: 12rem;
            }
        }
        .list4{
            font-size: 3rem;
            top: 7rem;
            position: absolute;
            text-align: center;
            right: 9rem;
            width: 15rem;
            li{
                position: relative;
                color: white;
                margin-top: 5.5rem;
                font-weight: 600;
                text-align: left;
            }
        }
    }
    .white{
        background: #222222;
        .title-box{
            color: white;
            .title:after{
                background: white;
            }
        }

    }
</style>
